import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { S25DropdownAbstract } from "../s25-dropdown/s25.dropdown.abstract";
import { S25Icons } from "./s25.icon.const";
import { S25Util } from "../../util/s25-util";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { DropDownItem } from "../../pojo/DropDownItem";
import { TypedTemplateContextDirective } from "../../standalone/typed.template.directive";
import { S25IconComponent } from "./s25.icon.component";

@Component({
    standalone: true,
    selector: "s25-ng-icon-dropdown",
    template: `
        <s25-generic-dropdown
            [choice]="choice"
            [useChoiceForChosen]="true"
            [value]="value()"
            [onSelect]="onSelect"
            [items]="items"
            [staticItems]="staticItems"
            [autoOpen]="autoOpen"
            [alwaysOpen]="alwaysOpen"
            [hideSearch]="hideSearch"
            [focusFirst]="false"
            [searchEnabled]="true"
            [apiBean]="apiBean"
            [placeholder]="''"
            [resetSelectedOnCleanup]="resetSelectedOnCleanup"
            [hasNoneItem]="hasNoneItem"
            [noneItemLabel]="noneItemLabel"
            [ariaLabel]="ariaLabel"
            (valueChange)="onValueChange($event)"
        />

        <ng-template #choice [templateContext]="choiceContext" let-item="item">
            @if (item.isNoneItem) {
                {{ noneItemLabel ?? "No Icon" }}
            } @else {
                <s25-ng-icon [type]="item.itemId" [ariaLabel]="false" /> {{ item.itemName }}
            }
        </ng-template>
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25DropdownPaginatedModule, TypedTemplateContextDirective, S25IconComponent],
})
export class S25IconDropdownComponent extends S25DropdownAbstract<string> {
    readonly choiceContext: { item: DropDownItem<string> };

    items = S25Util.entries(S25Icons.typed).map(([key, value]) => ({ itemId: key, itemName: value.title }));
}
